<template>
    <div class="modal fade" :id="modalId" :style="isStyle" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-fullscreen modal-invoice-template modal-dialog-scrollable" :class="dialogClass" :style="isStyle">
            <div class="modal-content position-relative" :style="isStyle">
                <!-- Close Button (only when no header is shown) -->
                <button v-if="!showHeader" type="button" id="close-modal-btn" class="btn-close position-absolute" style="top: 1rem; right: 1rem; z-index: 1; filter: invert(1);" @click="closeModal" aria-label="Close"></button>

                <!-- Modal Header Slot -->
                <div class="modal-header" v-if="showHeader">
                    <slot name="header"></slot>
                </div>

                <!-- Modal Body Slot -->
                <div class="modal-body" v-if="isOpen" :style="bodyStyle">
                    <slot name="body"></slot>
                </div>

                <!-- Modal Footer Slot -->
                <div class="modal-footer" v-if="showFooter">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomModal',
    props: {
        modalId: {
            type: String,
            required: true
        },
        isOpen: {
            type: Boolean,
            default: false
        },
        showFooter: {
            type: Boolean,
            default: true
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        isStyle: {
            type: String,
            required: false
        },
        bodyStyle: {
            type: String,
            required:  null
        },
        dialogClass: {
            type: String,
            default: ''
        }
    },
    mounted(){
        // eslint-disable-next-line no-undef
        this.createModal = new bootstrap.Modal(document.getElementById(this.modalId),{backdrop: 'static', keyboard: false})
        if(this.isOpen == true){
            this.createModal.show()
        }
        document.getElementById(this.modalId).addEventListener('hidden.bs.modal', () => { 
            this.$emit('modalClosed', true)
        })
    },
    watch : {
       isOpen(newVal) {
            if (newVal) {
                this.createModal.show()
            } else {
                this.createModal.hide()
            }
        }
    },
    methods: {
        closeModal() {
            this.$emit('update:isOpen', false);
            this.createModal.hide();
            this.$emit('modalClosed', true);
        }
    }
}
</script>

<style scoped>
.modal-xl.modal-custom-xl {
    max-width: 95%; /* Custom width */
}

.modal {
    font-size: 16px !important;
}

.modal-dialog.modal-fullscreen {
    width: 100vw !important;
    max-width: none !important;
    height: 100%;
    margin: 0 !important;
}

.modal-dialog.modal-fullscreen .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
    transform: none;
}

.btn-close:hover {
    opacity: 1;
}
</style>
